import { FC, memo } from 'react';
import clsx from 'clsx';
import { Icon } from '@marriott/mi-ui-library';

import { SkeletonLoaderV2 } from '../../../molecules/SkeletonLoaderV2';

type WalletWidgetContainerBadgeProps = {
  badgeIcon?: string;
  publishedText?: string;
};

export const WalletWidgetContainerBadge: FC<WalletWidgetContainerBadgeProps> = memo(({ badgeIcon, publishedText }) => {
  const isLoading = Boolean(badgeIcon && publishedText === undefined);
  const shouldRender = Boolean(publishedText) || isLoading;

  if (!shouldRender) return null;

  return (
    <div
      data-testid="wallet-widget-badge"
      className={clsx('wallet-widget-container__badge', isLoading && 'wallet-widget-container__badge--loading')}
      role="status"
      aria-label={publishedText ?? undefined}
    >
      {isLoading ? (
        <SkeletonLoaderV2 className="wallet-widget-container__badge-skeleton" />
      ) : (
        <>
          {badgeIcon && (
            <Icon iconClass={clsx('wallet-widget-container__badge-icon', badgeIcon)} isDecorative ariaLabel="" />
          )}
          {publishedText && <span className="wallet-widget-container__badge-text t-label-xs">{publishedText}</span>}
        </>
      )}
    </div>
  );
});

WalletWidgetContainerBadge.displayName = 'WalletWidgetContainerBadge';
